import React from "react";
import Events from "../../../utilities/EventEmitter";
import { MapConstant, MapHelper} from "../../../lib/Map";
import styles from "../../../layout/componentHeaderStyles";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../common/StyledToolTip";
class DrawingToolbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      draw: null,
      activeDrawMode: null,
      map: null,
    };
  }

  componentDidMount() {
    Events.on(MapConstant.EVENT.SET_MAP_DRAW, this.updateDrawObject);
  }

  componentWillUnmount() {
    Events.off(MapConstant.EVENT.SET_MAP_DRAW, this.updateDrawObject);
    this.clearMapEvents();
  }

  addMapEvents = () => {
    const { map } = this.state;
    if (map) {
      map.on("draw.modechange", this.changeDrawMode);
      map.on("draw.create", this.drawUpdated);
      map.on("draw.update", this.drawUpdated);
      map.on("draw.delete", this.drawDeleted);
    }
  };

  clearMapEvents = () => {
    const { map } = this.state;
    if (map) {
      map.off("draw.modechange", this.changeDrawMode);
      map.off("draw.create", this.drawUpdated);
      map.off("draw.update", this.drawUpdated);
      map.off("draw.delete", this.drawDeleted);
    }
  };

  updateDrawObject = ({
    eventType = "setMapDraw",
    map,
    draw,
    drawComplete,
  }) => {
    if (eventType === "clearDraw") {
      this.state.draw.deleteAll();
    } else {
      this.clearMapEvents();
      this.setState(
        {
          draw,
          map,
        },
        this.addMapEvents
      );
      this.drawComplete = drawComplete;
    }
  };

  changeDrawMode = (drawMode) => {
    // if feature is drawing is present always go direct select mode(allows to move vertices) from simple select
    const { draw } = this.state;
    const [mode, options] =
      draw.modes.SIMPLE_SELECT === drawMode.mode &&
      draw.getAll().features.length
        ? [
            draw.modes.DIRECT_SELECT,
            { featureId: draw.getAll().features[0].id },
          ]
        : [drawMode.mode, {}];
    this.setState({
      activeDrawMode: mode,
    });
    draw.changeMode(mode, options);
  };

  clearDraw = (event) => {
    if (this.state.draw) {
      this.drawDeleted(this.state.draw.getAll());
      this.state.draw.deleteAll();
    }
  };

  clearOlderDraws = (currentDrawFeatureId) => {
    Object.values(this.state.draw.getAll().features).forEach((feature) => {
      if (feature.id !== currentDrawFeatureId) {
        this.state.draw.delete(feature.id);
      }
    });
    this.clearDistanceInfo();
  };

  drawUpdated = (event) => {
    if (event && event.features && event.features.length) {
      this.clearOlderDraws(event.features[0].id);
      const drawType =
        event.features[0].geometry && event.features[0].geometry.type;
      switch (drawType) {
        case "LineString":
          this.updateDistance(event);
          break;
        case "Polygon":
          this.drawComplete(event.features[0].geometry.coordinates);
          break;
        default:
          console.log(`No handler found for drawmode ${drawType}`);
          break;
      }
    }
  };

  drawDeleted = (event) => {
    if (event && event.features[0]) {
      const drawType =
        event.features[0].geometry && event.features[0].geometry.type;
      switch (drawType) {
        case "LineString":
          this.clearDistanceInfo();
          break;
        case "Polygon":
          this.drawComplete([]);
          break;
        default:
          console.log(`No handler found for drawmode ${drawType}`);
          break;
      }
    }
  };

  clearDistanceInfo = () => {
    if (
      this.metricsContainer &&
      this.distanceContainer &&
      this.travelTimeContainer
    ) {
      this.metricsContainer.style.display = "none";
      this.distanceContainer.innerHTML = "";
      this.travelTimeContainer.innerHTML = "";
    }
  }

    drawDeleted = (event) => {
        if(event && event.features[0]){
            const drawType = event.features[0].geometry && event.features[0].geometry.type;
            switch (drawType) {
                case "LineString":   this.clearDistanceInfo();
                    break;
                case "Polygon": this.drawComplete([]);
                    break;
                default:
                    console.log(`No handler found for drawmode ${drawType}`)
                    break;
            }
        }
    }

    updateDistance = (event) => {
        this.distanceContainer = document.getElementById("distance");
        this.travelTimeContainer = document.getElementById("travelTime");
        this.metricsContainer = document.getElementById("metrics-container");

        const points = event.features?.[0].geometry.coordinates;

        MapHelper.getDistance(points).then(data => {
            this.metricsContainer.style.display = "block";
            if(data){
                this.distanceContainer.innerHTML = `Distance: ${data.distance} Miles`;
                this.travelTimeContainer.innerHTML = `Travel time: ${data.duration} Mins`;
            }else {
                this.metricsContainer.innerHTML = "Not able to get directions";
            }
        })
    }
    render(){
        const { classes } = this.props;
        const { draw, activeDrawMode } = this.state;
        return (
            <React.Fragment>
                {
                    this.props.lasso && (
                        <React.Fragment>
                            {draw?.modes?.DRAW_RECTANGLE ? (
                                <div
                                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${draw && activeDrawMode === draw.modes.DRAW_RECTANGLE ? classes.activeIcon: ""}`}
                                onClick={() => this.changeDrawMode({mode: draw ? draw.modes.DRAW_RECTANGLE : null})}
                            >
                                <Tooltip title="Draw a rectangle">
                                    <i className={`icon-icon_checkbox_unselected ${classes.actionIcon}`} />
                                </Tooltip>
                            </div>
                            ): null}
                            
                            <div
                                className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${draw && activeDrawMode === draw.modes.DRAW_POLYGON ? classes.activeIcon: ""}`}
                                onClick={() => this.changeDrawMode({mode: draw ? draw.modes.DRAW_POLYGON : null})}
                            >
                                <Tooltip title="Draw a shape">
                                    <i className={`icon-lasso-select ${classes.actionIcon}`} />
                                </Tooltip>
                            </div>
                        </React.Fragment>
                    )
                }
                {
                    this.props.measureTool && (
                        <div
                            className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${draw && activeDrawMode === draw.modes.DRAW_LINE_STRING ? classes.activeIcon: ""}`}
                            onClick={() => this.changeDrawMode({mode: draw ? draw.modes.DRAW_LINE_STRING : null})}
                        >
                            <Tooltip title="Measure tool">
                                <i className={`icon-icons-ruler ${classes.actionIcon}`} />
                            </Tooltip>
                        </div>
                    )
                }
                {
                    this.props.delete && (
                        <div
                            className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons ${classes.enabledIcon}`}
                            onClick={this.clearDraw}
                        >
                            <Tooltip title="Delete">
                                <i className={`icon-icon_delete ${classes.actionIcon}`} />
                                </Tooltip>
                        </div>
                    )
                }
            </React.Fragment>
        )
    }
}

export default withStyles(styles)(DrawingToolbox);
